import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  Alert,
  Box,
} from '@mui/material';

const STAFF_TYPES = [
  { value: 'admin', label: 'Administrator' },
  { value: 'nurse', label: 'Nurse' },
  { value: 'carer', label: 'Carer' },
];

const AddStaffDialog = ({ open, onClose, onAdd }) => {
  const [form, setForm] = useState({
    username: '',
    email: '',
    password: '',
    first_name: '',
    last_name: '',
    staff_name: '',
    type_of_career: 'carer',
    qualification: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setLoading(true);
    try {
      await onAdd(form);
      setForm({
        username: '',
        email: '',
        password: '',
        first_name: '',
        last_name: '',
        staff_name: '',
        type_of_career: 'carer',
        qualification: '',
      });
    } catch (err) {
      setError(err.message || 'Failed to add staff member');
    }
    setLoading(false);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Add Staff</DialogTitle>
      <DialogContent>
        {error && <Alert severity="error">{error}</Alert>}
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
          <TextField label="Username" name="username" value={form.username} onChange={handleChange} fullWidth margin="normal" required />
          <TextField label="Email" name="email" value={form.email} onChange={handleChange} fullWidth margin="normal" required />
          <TextField label="Password" type="password" name="password" value={form.password} onChange={handleChange} fullWidth margin="normal" required />
          <TextField label="First Name" name="first_name" value={form.first_name} onChange={handleChange} fullWidth margin="normal" required />
          <TextField label="Last Name" name="last_name" value={form.last_name} onChange={handleChange} fullWidth margin="normal" required />
          <TextField label="Display Name" name="staff_name" value={form.staff_name} onChange={handleChange} fullWidth margin="normal" required />
          <TextField select label="Role" name="type_of_career" value={form.type_of_career} onChange={handleChange} fullWidth margin="normal">
            {STAFF_TYPES.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
          <TextField label="Qualification" name="qualification" value={form.qualification} onChange={handleChange} fullWidth margin="normal" required />
          <DialogActions>
            <Button onClick={onClose} disabled={loading}>
              Cancel
            </Button>
            <Button type="submit" variant="contained" disabled={loading}>
              {loading ? 'Saving...' : 'Add Staff'}
            </Button>
          </DialogActions>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default AddStaffDialog;
